module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kanto-2-9a37c3dc3bd28657d03e9096de33e747.jpg";